import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Locale from "@/locale";
import ErrorView from "@/views/ErrorView.vue";
import MemberApplicationView from "@/views/membership/MembersApplicationView.vue";
import AppreciationScreenView from "@/views/membership/AppreciationScreenView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/upload",
    name: "MemberShip",
    meta: {
      title: "Membership Application",
      auth: false,
      passive: true,
    },
    component: MemberApplicationView,
  },
  {
    path: "/thankyou",
    name: "thankyou",
    meta: {
      title: "Membership Application",
      auth: false,
      passive: true,
    },
    component: AppreciationScreenView,
  },  
  {
    path: "/:pathMatch(.*)*",
    name: "error",
    meta: {
      title: Locale.get('page.not.found'),
      auth: false,
      passive: true,
    },
    component: ErrorView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
});

router.beforeEach((to) => {
  const title = to.meta.title as any;
  document.title = title?.toString();
});

export default router;
